import {
    Component, EventEmitter, Input, OnInit, Output, ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CaptchaComponent } from '../../components/captcha/captcha.component';

@Component({
    selector: 'app-enter-old-password',
    templateUrl: './enterOldPassword.component.html',
    styleUrls: ['./enterOldPassword.component.scss'],
})
export class EnterOldPasswordComponent implements OnInit {

    private _catchaValidationErrorTranslate: string;

    constructor(
        private _translateService: TranslateService,
    ) {

    }

    public errorText: string;
    public oldPasswordValue: string;
    public showCaptcha = false;
    public captchaCode: string;


    @ViewChild('captchaComponent') captchaComponent: CaptchaComponent;
    @Input() submitButtonText: string;
    @Output() submited = new EventEmitter();

    ngOnInit(): void {
        this._initTranslations();
    }

    private _initTranslations() {
        this._translateService.get(
                [
                    'Common.CaptchaValidationError',
                ])
            .subscribe(
                result => {
                    this._catchaValidationErrorTranslate = result['Common.CaptchaValidationError'];
                });
    }


    public submitButtonClick(event: Event): void {
        this.errorText = null;
        this.submited.emit();
    }

    public captchaError(): void {
        this.errorText = this._catchaValidationErrorTranslate;
        this.captchaComponent.refreshCaptcha();
    }

    public clear() {
        this.errorText = null;
        this.oldPasswordValue = null;
        this.captchaComponent.refreshCaptcha();
    }
}
